/**
 * Pull the first hex color from a brand-kit `primaryColors` string.
 * The field is a comma-separated list of hex values (see ShowcaseBranding).
 *
 * Accepts both long-form (`#abcdef`, `abcdef`) and short-form
 * (`#abc`, `abc`). Short-form values are normalized to long-form
 * (each digit doubled) so downstream consumers can rely on a 7-char
 * `#RRGGBB` output. Returns `null` for empty / invalid input.
 */
export const parsePrimaryBrandColor = (
  primaryColors: string | null | undefined,
): string | null => {
  if (!primaryColors) return null;
  const first = primaryColors.split(',')[0]?.trim();
  if (!first) return null;
  const withHash = first.startsWith('#') ? first : `#${first}`;
  // Long form: #RRGGBB — return as-is.
  if (/^#[0-9a-fA-F]{6}$/.test(withHash)) return withHash;
  // Short form: #RGB — expand each digit (e.g. #abc → #aabbcc).
  if (/^#[0-9a-fA-F]{3}$/.test(withHash)) {
    const [, r, g, b] = withHash;
    return `#${r}${r}${g}${g}${b}${b}`;
  }
  return null;
};
